import D from '@/components/productSmart/smartDevices/treaser/components/D';
import { getSamrtDevicesTimeline, scrollToLive } from '@/constants/smartDevice';
import { getHostApi } from '@/utils';
import getDefaultHeader from '@/utils/singUtil/getDefaultHeader';
import { useGlobal } from '@/utils/useGlobal';
import dynamic from 'next/dynamic';
import { useRef } from 'react';
import A from './components/A';
import css from './index.module.scss';

const PageConH5 = dynamic(() => import('@/componentsH5/productSmart/smartDevices/treaser/indexDynamic'), {
    ssr: true,
});

export default function smartDevicesTreaserH5({ serverTime, ecoflowflag, ecoflowflag2, ecoflowflag3 }: any) {
    const { useState, useEffect, getSystemTime, useRouter } = useGlobal();
    const liveRef = useRef<HTMLDivElement>(null);
    const router = useRouter();
    const { locale } = router;
    const { video } = router.query;
    const TIME_LINE = getSamrtDevicesTimeline(ecoflowflag3);

    // 服务器时间
    const serverTimeStamp: any = useRef(getSystemTime());
    // 倒计时三个时间段
    const startTimeStamp: number = new Date(TIME_LINE?.teaser || 0).getTime();
    const detailTimeStamp: number = new Date(TIME_LINE?.detail || 0).getTime();
    const shopifyTimeStamp = new Date(TIME_LINE?.shopify[locale] || TIME_LINE?.shopify['us'] || 0).getTime();
    // 阶段 1: 预热 2: 开售 3. 详情（shopify)
    const [stage, setStage] = useState(ecoflowflag || serverTimeStamp?.current < detailTimeStamp ? 1 : serverTimeStamp?.current > shopifyTimeStamp ? 3 : 2);

    // 计时器
    const timer: any = useRef(null);

    const onVisibleChange = async () => {
        if (window.document.visibilityState === 'visible') {
            serverTimeStamp.current = getSystemTime();
            // 测试环境异常
            if (serverTimeStamp?.current < 1000000) {
                (async () => {
                    const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                    const headers: any = getDefaultHeader(locale);

                    try {
                        const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                            headers,
                        });
                        const globalData = await spuData.json();
                        serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                    } catch (e) {
                        console.log(e);
                    }
                })();
            }
        }
    };

    useEffect(() => {
        // 测试环境异常
        if (serverTimeStamp?.current < 1000000) {
            (async () => {
                const API_HOST = getHostApi(locale).NEXT_PUBLIC_API_HOST;
                const headers: any = getDefaultHeader(locale);

                try {
                    const spuData = await fetch(`${API_HOST}/serverTimestamp?locale=${locale}`, {
                        headers,
                    });
                    const globalData = await spuData.json();
                    serverTimeStamp.current = globalData?.data?.timestamp || new Date().getTime();
                } catch (e) {
                    console.log(e);
                }
            })();
        }
        // 倒计时结束完成之前一直执行定时器任务
        if (serverTimeStamp.current < shopifyTimeStamp && shopifyTimeStamp !== 0) {
            timer.current = setInterval(() => {
                serverTimeStamp.current += 1000;
                if (serverTimeStamp.current >= shopifyTimeStamp) {
                    clearInterval(timer.current);
                    return stage !== 3 && setStage(3);
                }
                if (serverTimeStamp.current >= detailTimeStamp) {
                    return stage !== 2 && setStage(2);
                }
                if (serverTimeStamp.current >= startTimeStamp) {
                    return stage !== 1 && setStage(1);
                }
            }, 1000);
        } else {
            clearInterval(timer.current);
        }
        if (typeof window !== 'undefined') {
            // 监听切屏事件
            window.document.addEventListener('visibilitychange', onVisibleChange);
        }
        return () => {
            clearInterval(timer.current);
        };
    }, []);

    useEffect(() => {
        setTimeout(() => {
            const offset = window.safari ? 923 : 100;
            scrollToLive(liveRef.current as HTMLDivElement, video, offset);
        }, 50);
    }, []);
    return (
        <div className={`smart-devices-treaser-h5 ${css.smartDevicesTreaserH5}`}>
            <A stage={stage} />
            <PageConH5 serverTime={serverTime} stage={stage} />
            <div ref={liveRef}>
                <D />
            </div>
        </div>
    );
}
